// extracted by mini-css-extract-plugin
export default {"guideAnimation":"guideAnimation-MhcLDt","moveUp":"moveUp-ZxeGim","guide-wrap":"guide-wrap-mSGLir","button":"button-gvQsGn","opacity":"opacity-yw9Uim"};